import { setLocal, destructUrl } from "src/utils/functions/core"
import { notification } from 'antd';
// import { socket } from 'src/utils/socket';
import { getFetch } from "src/utils/functions/queryRoute"
const uuidv4 = require("uuid").v4;

const _socket = (result) => {
  const { socket } = require("src/utils/socket")
  // socket.connect();
  socket.emit("login", {
    userId: result.body.user._id,
    token: result.body.token,
    loginTime: Date.now(),
    userSession: result.body.user.parameters.userConfig.localStorageExpired
  })
  socket.off("login")
}

const sendCredentials = (url = "", data = {}) => {
  const browserId = uuidv4()
  // console.log(data)
  return (
    fetch(url, {
      method: "POST",
      mode: 'cors',
      credentials: 'same-origin',
      headers: new Headers({
        "Content-Type": "application/json",
        "browserId": browserId
      }),
      body: JSON.stringify(data),
    })
      .then((res) => {
        // console.log(res)
        setLocal("browserId", browserId)
        return res.json();
      })
      .catch((error) => console.log(error))
  );
}

const setData = async(result, navigate) => {
  // const licence = await getFetch("getValidLicenseFe", {})
  // console.log(licence)
  const homeUrl = result?.body?.user?.parameters?.homeUrl ?? "/home"
  const rangeTime = result?.body?.user?.parameters?.userConfig?.rangeTime
  setLocal("rangeTime", rangeTime)
  if (result?.body?.pages?.length > 0) {
    const findRoute = result?.body?.pages?.find((f) => f.route === "/home")
    if (findRoute) {
      // console.log("1")
      // setIsLoading(false)
      setLocal("body", result.body)
      // localStorage.setItem("body", JSON.stringify(result.body))
      const search = result?.body?.user?.param?.search
      // const search = "?size=" + (collapsed ? "80" : "200") + "&collapsed=" + collapsed
      _socket(result)
      // history.push({ pathname: homeUrl, isAuthenticated: true, body: result.body, search })
      navigate({ pathname: homeUrl, isAuthenticated: true, body: result.body, search })
      return false
    } else {
      // console.log("2")
      const checkIfHomeUrlExit = result?.body?.user?.parameters?.homeUrl ?? false
      // console.log(checkIfHomeUrlExit)
      if (checkIfHomeUrlExit) {
        // setIsLoading(false)
        setLocal("body", result.body)
        // localStorage.setItem("body", JSON.stringify(result.body))
        const search = result?.body?.user?.param?.search
        // const search = "?size=" + (collapsed ? "80" : "200") + "&collapsed=" + collapsed
        _socket(result)
        // history.push({ pathname: homeUrl, isAuthenticated: true, body: result.body, search })
        navigate({ pathname: homeUrl, isAuthenticated: true, body: result.body, search })
        // setIsLoading(false)
        return false
      } else {
        // setIsLoading(false)
        // msg("error", "code 001", 60)
        notification["error"]({
          message: 'No premissons on home route',
          description: 'Please contact your admin - code 001',
        });
        return false
      }
    }
  } else {
    // setIsLoading(false)
    notification["error"]({
      message: 'No premissons',
      description: 'Please try again !!!',
    });
    return false
  }
}


const sendCredentialsPin = (url = "", data = {}) => {
  const browserId = uuidv4()
  // console.log(data)
  // console.log(url)
  return (
    fetch(url, {
      method: "POST",
      mode: 'cors',
      credentials: 'same-origin',
      headers: new Headers({
        "Content-Type": "application/json",
        "browserId": browserId
      }),
      body: JSON.stringify(data),
    })
      .then((res) => {
        setLocal("browserId", browserId)
        return res.json();
      })
      .catch((error) => console.log(error))
  );
}

const setDataPin = async(result, navigate) => {
  // const licence = await getFetch("getValidLicenseFe", {})
  const pages = await result?.body?.pages.filter((el) => el.route.includes("terminalMode"))
  const _widgets = await result?.body?.licence?._widgets.filter((el) => el.portalId)
  result.body.pages = pages
  result.body.licence._widgets = _widgets
  const homeUrl = (result?.body?.user?.parameters?.terminalUrl) ?? "/home"
  // console.log(result?.body?.user)
  const rangeTime = result?.body?.user?.parameters?.userConfig?.rangeTime
  setLocal("rangeTime", rangeTime)
  if (result?.body?.pages?.length > 0) {
    const findRoute = true//result?.body?.pages?.find((f) => f.route === "/home")
    // console.log(result)
    if (findRoute) {
      // console.log("1")
      // setIsLoading(false)
      setLocal("body", result.body)
      // localStorage.setItem("body", JSON.stringify(result.body))
      const search = "?id=" + result?.body?.user?._id
      // const search = "?size=" + (collapsed ? "80" : "200") + "&collapsed=" + collapsed
      _socket(result)
      // history.push({ pathname: homeUrl, isAuthenticated: true, body: result.body, search })
      navigate({ pathname: homeUrl, search })
      return false
    } else {
      // console.log("2")
      const checkIfHomeUrlExit = result?.body?.user?.parameters?.terminalUrl ?? false
      // console.log(checkIfHomeUrlExit)
      // console.log(result.body)
      if (checkIfHomeUrlExit) {
        // setIsLoading(false)
        setLocal("body", result.body)
        // localStorage.setItem("body", JSON.stringify(result.body))
        const search = "?id=" + result?.body?.user?._id
        // const search = "?size=" + (collapsed ? "80" : "200") + "&collapsed=" + collapsed
        _socket(result)
        // history.push({ pathname: homeUrl, isAuthenticated: true, body: result.body, search })
        navigate({ pathname: homeUrl, search })
        // setIsLoading(false)
        return false
      } else {
        // setIsLoading(false)
        // msg("error", "code 001", 60)
        notification["error"]({
          message: 'No premissons on home route',
          description: 'Please contact your admin - code 001',
        });
        return false
      }
    }
  } else {
    // setIsLoading(false)
    notification["error"]({
      message: 'No premissons',
      description: 'Please try again !!!',
    });
    return false
  }
}

export {
  sendCredentials,
  _socket,
  setData,
  sendCredentialsPin,
  setDataPin
}
